// import React from 'react'
// import { useState } from 'react';
// import { PhoneOutlined, MailOutlined, BookOutlined,BulbOutlined, PictureOutlined, EnvironmentOutlined} from '@ant-design/icons';
// import {Menu} from 'antd';
// import themepicture from '../Assets/Photos/themePhoto.png'
// import schoolLogo from '../Assets/Photos/schoolLogo.jpeg'
// import ourSchool from '../Assets/Photos/ourSchoolEdited.png';
// import studentActivity from '../Assets/Photos/studentActivity.jpeg';
// import { Tabs, Carousel} from 'antd';
// import schoolphoto1 from '../Assets/Photos/SchoolPhoto1.jpeg';
// import schoolphoto3 from '../Assets/Photos/Schoolphoto3.jpeg';
// import schoolphoto4 from '../Assets/Photos/SchoolPhoto4.jpeg';
// import schoolphoto5 from '../Assets/Photos/Schoolphoto5.jpeg';
// import schoolphoto6 from '../Assets/Photos/SchoolPhoto6.jpeg';
// import schoolphoto7 from '../Assets/Photos/Schoolphoto7.jpeg';
// import schoolphoto8 from '../Assets/Photos/SchoolPhoto8.jpeg';
// import schoolphoto9 from '../Assets/Photos/SchoolPhoto9.jpeg';
// import schoolphoto10 from '../Assets/Photos/SchoolPhoto10.jpeg';
// import schoolphoto11 from '../Assets/Photos/SchoolPhoto11.jpeg';
// import schoolphoto12 from '../Assets/Photos/SchoolPhoto12.jpeg';


// const ProgramsTabs = () => {

//     const items = [
//       {
//         key: '1',
//         label: <span style={{ fontFamily: 'Quicksand', fontSize: '0.7cm' }}>PlayGroup</span>,
//         children: (
//             <div style={{ display: "flex", alignItems: "center", gap: "2cm" }}>
//                 {/* Image */}
//                 <img src={schoolphoto5} alt="schoolphoto" style={{ width: "15cm", height: "6cm", borderRadius: "10px" }} />
                
//                 {/* Text Content */}
//                 <div style={{ fontFamily: 'sans-serif', textAlign: "left" }}>
//                     <h5 style={{ color: "red" }}>Playgroup (Age: 1.5 - 3 years)</h5>
//                     <p>Our Playgroup program focuses on sensory experiences, social interaction, and early learning in a fun, engaging environment.</p>
//                     <ul>
//                         <li>🎨 Creative play and storytelling</li>
//                         <li>🎶 Music, dance, and art activities</li>
//                         <li>🔢 Introduction to numbers, shapes, and letters</li>
//                         <li>🤝 Social interaction and emotional development</li>
//                     </ul>
//                 </div>
//             </div>
//         ),
//       },
//       {
//         key: '2',
//         label: <span style={{ fontFamily: 'Quicksand', fontSize: '0.7cm' }}>LKG</span>,
//         children: (
//             <div style={{ display: "flex", alignItems: "center", gap: "2cm" }}>
//                 {/* Image */}
//                 <img src={schoolphoto7} alt="LKG" style={{ width: "15cm", height: "6cm", borderRadius: "10px" }} />
                
//                 {/* Text Content */}
//                 <div style={{ fontFamily: 'sans-serif', textAlign: "left" }}>
//                 <h5 style={{ color: "red" }}>LKG (Age: 4 - 5 years)</h5>
//                 <p>Our LKG program enhances foundational skills in literacy, numeracy, and social interaction, fostering curiosity and confidence in young learners.</p> 
//                 <ul> 
//                     <li>📖 Advanced early reading and writing activities</li> 
//                     <li>🔢 Strengthening basic math concepts with interactive learning</li> 
//                     <li>🌱 Hands-on exploration of science and the environment</li> 
//                     <li>🎭 Engaging role-playing, storytelling, and creative expression</li> 
//                 </ul>
//                 </div>
//             </div>
//         ),
//       },
//       {
//         key: '3',
//         label: <span style={{ fontFamily: 'Quicksand', fontSize: '0.7cm' }}>UKG</span>,
//         children: (
//             <div style={{ display: "flex", alignItems: "center", gap: "2cm" }}>
//                 {/* Image */}
//                 <img src={schoolphoto5} alt="schoolphoto" style={{ width: "15cm", height: "6cm", borderRadius: "10px" }} />
                
//                 {/* Text Content */}
//                 <div style={{ fontFamily: 'sans-serif', textAlign: "left" }}>
//                 <h5 style={{ color: "red" }}>UKG (Age: 5 - 6 years)</h5>
//                 <p>Our UKG program strengthens literacy, numeracy, and critical thinking skills, ensuring a smooth transition to primary school.</p>
//                     <ul>
//                         <li>📖 Advanced reading and writing exercises</li>
//                         <li>🔢 Enhanced math concepts and logical reasoning</li>
//                         <li>🌍 Exploration of science and environmental studies</li>
//                         <li>💡 Problem-solving, creativity, and group activities</li>
//                     </ul>
//                 </div>
//             </div>
//         ),
//       },
//       {
//         key: '4',
//         label: <span style={{ fontFamily: 'Quicksand', fontSize: '0.7cm' }}>First Grade</span>,
//         children: (
//             <div style={{ display: "flex", alignItems: "center", gap: "2cm" }}>
//                 {/* Image */}
//                 <img src={schoolphoto7} alt="LKG" style={{ width: "15cm", height: "6cm", borderRadius: "10px" }} />
                
//                 {/* Text Content */}
//                 <div style={{ fontFamily: 'sans-serif', textAlign: "left" }}>
//                 <h5 style={{ color: "red" }}>First Grade (Age: 6 - 7 years)</h5>
//                 <p>Our First Grade program builds on foundational skills, fostering independence, critical thinking, and academic excellence.</p>
//                     <ul>
//                         <li>📖 Advanced reading comprehension and writing skills</li>
//                         <li>🔢 Introduction to addition, subtraction, and logical reasoning</li>
//                         <li>🌍 Basic science and environmental awareness</li>
//                         <li>💡 Hands-on learning, problem-solving, and creativity</li>
//                         <li>🗣️ Communication skills through discussions and storytelling</li>
//                     </ul>
//                 </div>
//             </div>
//         ),
//       },
//       {
//         key: '5',
//         label: <span style={{ fontFamily: 'Quicksand', fontSize: '0.7cm' }}>Second Grade</span>,
//         children: (
//             <div style={{ display: "flex", alignItems: "center", gap: "2cm" }}>
//                 {/* Image */}
//                 <img src={schoolphoto7} alt="LKG" style={{ width: "15cm", height: "6cm", borderRadius: "10px" }} />
                
//                 {/* Text Content */}
//                 <div style={{ fontFamily: 'sans-serif', textAlign: "left" }}>
//                 <h5 style={{ color: "red" }}>Second Grade (Age: 7 - 8 years)</h5>
//                 <p>Our Second Grade program enhances academic skills, critical thinking, and creativity while fostering confidence and independence.</p>
//                     <ul>
//                         <li>📖 Improved reading fluency, vocabulary, and creative writing</li>
//                         <li>🔢 Stronger math skills including multiplication, division, and problem-solving</li>
//                         <li>🌍 Deeper exploration of science, environment, and social studies</li>
//                         <li>💡 Critical thinking through experiments and hands-on projects</li>
//                         <li>🗣️ Public speaking, storytelling, and structured communication</li>
//                     </ul>
//                 </div>
//             </div>
//         ),
//       }
//     ];
  
//     return <Tabs defaultActiveKey="1" items={items} />;
//   };
// export default function MainPage() {
    
//     const [current, setCurrent] = useState("about");

//     const items = [
//         { label: "Why Achiever", key: "Why Achiever", icon: <BulbOutlined /> },
//         { label: "Programs", key: "programs", icon: <BookOutlined /> },
//         { label: "Photos", key: "photos", icon: <PictureOutlined /> },
//         { label: "Contact", key: "Contact", icon: <PhoneOutlined /> },
//     ];
      
//     const onClick = (e) => 
//     {
//         setCurrent(e.key);
//         const section = document.getElementById(e.key);
//         if (section) 
//         {
//           section.scrollIntoView({ behavior: "smooth", block: "start" });
//         }
//     }    
      
    
//   return (
//     <div>
//         <div className="row">
//             <div className="col-12 text-black text-start pb-4">
//                 <div className="row align-items-center d-flex justify-content-between">
//                     {/* Logo Placeholder */}
//                     <div className="col-auto">
//                         <img src={schoolLogo} alt="School logo" style={{height:"3cm", width:"4cm"}}/>
//                     </div>

//                     {/* Ant Design Menu */}
//                     <div className="col flex-grow-1" style={{marginLeft:"6.2cm"}} >
//                     <Menu
//                         onClick={onClick}
//                         selectedKeys={[current]}
//                         mode="horizontal"
//                         items={items}
//                         className="border-0"
//                         style={{ fontFamily:"Aceh SoftRegular", fontSize:"0.6cm" }}
//                     />
//                     </div>
//                     <div className="col-auto">
//                         <button className="btn btn-primary" onClick={() => window.alert("Call Us at +91-9960132474 / +91-9370130130")}>Enquire</button>
//                     </div>
//                 </div>
//             </div>

//             <div className="col-12 p-0 position-relative">
//                 <img src={themepicture} alt="TeacherAndChildrenImage" style={{width:"92%", height:"20cm"}} className="object-fit-cover" />
//             </div>

//             <div className="col-12 text-center p-3 mt-4" style={{marginTop:"2cm"}} id='Why Achiever'>
//                 <h1 style={{ 
//                     fontFamily: "Quicksand",
//                     fontWeight:"bold", 
//                     transition: "text-decoration 0.3s ease",
//                     textDecorationColor: "transparent",
//                     color: "red"
//                 }} 
//                 onMouseEnter={(e) => {
//                     e.target.style.textDecoration = "underline";
//                     e.target.style.textDecorationColor = "red";
//                 }} 
//                 onMouseLeave={(e) => {
//                     e.target.style.textDecoration = "none";
//                     e.target.style.textDecorationColor = "transparent";
//                 }}>
//                     Why Achiever's  🏆
//                 </h1>
//                 <h2 className='mt-4 text-center w-75 mx-auto' style={{fontFamily:"sans-serif", fontWeight: 300}}>
//                     No two kids are the same, then why should they learn the same thing, the same way and at the same pace as every other kid?
//                 </h2>
//                 <h5 className='mt-2 text-center w-75 mx-auto'>
//                     At Achievers, we believe that every child is unique with innovative skills and abilities that need nurturing. With this philosophy at the heart of everything we do have developed a personlised learning methodology that involves skill-based lessons and engaging activities that enable your child to hone his/her individual abilities.
//                 </h5>
//             </div>
            
//             <div className="col-12 p-3" style={{marginTop:"2cm"}}>
//                 <div className='row align-items-center d-flex justify-content-between'>
//                     <div className="col-auto m-1">
//                         <img src={ourSchool} alt="Our School" style={{width:"17cm", height:"15cm" }} />
//                     </div>
//                     <div className='col-auto' style={{width:"50%"}}>
//                         <h2 style={{fontStyle:"bold", color:"red"}}>
//                             <b>Our School</b>
//                         </h2>
//                         <h4 style={{ lineHeight: "1.6", textAlign: "left" }}>
//                             At <b>Achiever’s School</b>, we create a <b>nurturing</b> and <b>inspiring</b> space where young minds 
//                             <b> learn, play, and grow</b> with <b>curiosity and confidence</b>. Our <b>child-centered approach </b> 
//                             encourages <b>creativity</b>, <b>critical thinking</b>, and a <b>lifelong love for learning</b>.  
//                             <br /><br />
//                             ✨ <b>Why Choose Us?</b>
//                             <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
//                                 <li>✅ <b>A safe and engaging environment</b> for your child’s development</li>
//                                 <li>✅ <b>Fun-filled learning</b> that sparks imagination and discovery</li>
//                                 <li>✅ <b>A strong foundation</b> to help every child achieve their full potential!</li>
//                             </ul>
//                             <br />
//                             <b>Join us</b> on this wonderful journey of <b>growth and learning!</b> 🚀🎨📚
//                         </h4>
//                     </div>
//                 </div>
//                 <div className='row align-items-center d-flex justify-content-between' style={{marginTop:"2cm"}}>
//                     <div className="col-auto m-5"  style={{width:"50%"}}>
//                         <h2 style={{fontStyle:"bold", color:"red", textAlign:"left"}}>
//                             <b>A learning experience as unique as your child</b>
//                         </h2>
//                         <h4 style={{ lineHeight: "1.6", textAlign: "left" }}>
//                             We <b>customize learning</b> for each child based on their <b>strengths, needs, and skill level</b>,  
//                             ensuring that every child stays <b>engaged and happy</b>.  
//                             <br /><br />
//                             At Achiever’s School, children learn at their <b>own pace</b>, unlocking new levels of learning  
//                             <b> only when they have mastered an activity</b>. This builds confidence, independence, and a  
//                             love for discovery! 🌟📚🎈
//                         </h4>
//                     </div>
//                     <div className='col-auto'>
//                         <img src={studentActivity} alt="Our School" style={{width:"11cm", height:"10cm", marginRight:"1cm" }} />
//                     </div>
                    
//                 </div>
//             </div>

//             <div className="col-12" id='programs'>
//                 <h1 style={{ 
//                     fontFamily: "Quicksand",
//                     fontWeight:"bold", 
//                     transition: "text-decoration 0.3s ease",
//                     textDecorationColor: "transparent",
//                     color: "red",
//                     marginTop:"2cm"
//                 }} 
//                 onMouseEnter={(e) => {
//                     e.target.style.textDecoration = "underline";
//                     e.target.style.textDecorationColor = "red";
//                 }} 
//                 onMouseLeave={(e) => {
//                     e.target.style.textDecoration = "none";
//                     e.target.style.textDecorationColor = "transparent";
//                 }}>
//                     Programs  📚
//                 </h1>   
//                 <div style={{marginLeft:"2cm", marginRight:"2cm", marginTop:"1cm"}}>
//                     <ProgramsTabs/>
//                 </div> 
//             </div>

//             <div className="col-12 p-3" style={{marginTop:"2cm"}} id='photos'>
//                 <h1 style={{ 
//                     fontFamily: "Quicksand",
//                     fontWeight:"bold", 
//                     transition: "text-decoration 0.3s ease",
//                     textDecorationColor: "transparent",
//                     color: "red"
//                 }} 
//                 onMouseEnter={(e) => {
//                     e.target.style.textDecoration = "underline";
//                     e.target.style.textDecorationColor = "red";
//                 }} 
//                 onMouseLeave={(e) => {
//                     e.target.style.textDecoration = "none";
//                     e.target.style.textDecorationColor = "transparent";
//                 }}>
//                       Photos  📸
//                 </h1>
//                 <Carousel autoplay style={{marginTop:"1cm"}}>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px", textAlign:"center" }}>
//                         <img src={schoolphoto1} alt="schoolPhoto" style={{width:"100%", height:"10cm", paddingLeft:"7cm", paddingRight:"7cm" }} />
//                     </div>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
//                         <img src={schoolphoto3} alt="schoolPhoto" style={{width:"100%", height:"10cm", paddingLeft:"7cm", paddingRight:"7cm"}} />
//                     </div>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
//                         <img src={schoolphoto4} alt="schoolPhoto" style={{width:"100%", height:"10cm", paddingLeft:"7cm", paddingRight:"7cm"}} />
//                     </div>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
//                         <img src={schoolphoto6} alt="schoolPhoto" style={{width:"100%", height:"10cm", paddingLeft:"7cm", paddingRight:"7cm"}} />
//                     </div>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
//                         <img src={schoolphoto8} alt="schoolPhoto" style={{width:"100%", height:"10cm", paddingLeft:"7cm", paddingRight:"7cm"}} />
//                     </div>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
//                         <img src={schoolphoto9} alt="schoolPhoto" style={{width:"100%", height:"10cm", paddingLeft:"7cm", paddingRight:"7cm"}} />
//                     </div>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
//                         <img src={schoolphoto10} alt="schoolPhoto" style={{width:"100%", height:"10cm", paddingLeft:"7cm", paddingRight:"7cm"}} />    
//                     </div>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
//                         <img src={schoolphoto11} alt="schoolPhoto" style={{width:"100%", height:"10cm", paddingLeft:"7cm", paddingRight:"7cm"}} />    
//                     </div>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
//                         <img src={schoolphoto12} alt="schoolPhoto" style={{width:"100%", height:"10cm", paddingLeft:"7cm", paddingRight:"7cm"}} />    
//                     </div>
//                 </Carousel>
//             </div>
            
//             <div className="col-12 text-center p-3" style={{marginTop:"2cm"}} id='Contact'>
//                 <h1 style={{ 
//                     fontFamily: "Quicksand",
//                     fontWeight:"bold", 
//                     transition: "text-decoration 0.3s ease",
//                     textDecorationColor: "transparent",
//                     color: "red"
//                 }} 
//                 onMouseEnter={(e) => {
//                     e.target.style.textDecoration = "underline";
//                     e.target.style.textDecorationColor = "red";
//                 }} 
//                 onMouseLeave={(e) => {
//                     e.target.style.textDecoration = "none";
//                     e.target.style.textDecorationColor = "transparent";
//                 }}>
//                       Contact  ☎️
//                 </h1>
//                 <h3 className='mt-4' style={{fontFamily:"sans-serif", fontSize:"0.5cm", fontWeight: 300}}>
//                     <EnvironmentOutlined style={{ color: "blue" }} /> Address 1: Achiever's School,Krushna Kunj Phase - 1, Lonikand
//                 </h3>
//                 <h3 className='mt-4' style={{fontFamily:"sans-serif", fontSize:"0.5cm", fontWeight: 300}}>
//                     <EnvironmentOutlined style={{ color: "blue" }} /> Address 2: Achiever's School, Near Bakori.
//                 </h3>
//                 <h3 className='mt-4' style={{fontFamily:"sans-serif", fontSize:"0.5cm", fontWeight: 300}}>
//                     <PhoneOutlined style={{ color: "blue" }} /> Contact: +91-9960132474 / +91-9370130130
//                 </h3>
//                 <h3 className='mt-4' style={{fontFamily:"sans-serif", fontSize:"0.5cm", fontWeight: 300}}>
//                     <MailOutlined style={{ color: "blue" }} /> E-Mail: achievers.school.lonikand@gmail.com
//                 </h3>
                

//             </div>
//             <div className="col-12 bg-dark text-white text-center p-3"></div>
//         </div>
//     </div>
//   )
// }

import '../Styles/main.css'; 
import React, { useState, useEffect } from 'react';
import { PhoneOutlined, MailOutlined, BookOutlined, BulbOutlined, PictureOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import themepicture from '../Assets/Photos/themePhoto.png';
import schoolLogo from '../Assets/Photos/schoolLogo.jpeg';
import ourSchool from '../Assets/Photos/ourSchoolEdited.png';
import studentActivity from '../Assets/Photos/studentActivity.jpeg';
import { Carousel, Collapse } from 'antd';
import schoolphoto1 from '../Assets/Photos/SchoolPhoto1.jpeg';
import schoolphoto3 from '../Assets/Photos/Schoolphoto3.jpeg';
import schoolphoto4 from '../Assets/Photos/SchoolPhoto4.jpeg';
import schoolphoto6 from '../Assets/Photos/SchoolPhoto6.jpeg';
import schoolphoto8 from '../Assets/Photos/SchoolPhoto8.jpeg';
import schoolphoto9 from '../Assets/Photos/SchoolPhoto9.jpeg';
import schoolphoto10 from '../Assets/Photos/SchoolPhoto10.jpeg';
import schoolphoto11 from '../Assets/Photos/SchoolPhoto11.jpeg';
import schoolphoto12 from '../Assets/Photos/SchoolPhoto12.jpeg';
import { ProgramsTabs, items } from './ProgramsTabs';


export default function MainPage() {
  const [current, setCurrent] = useState("about");
  const [isMobile, setIsMobile] = useState(false);
  const [tabItems, setTabItems] = useState([]);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const item = [
    { label: "Why Achiever", key: "Why Achiever", icon: <BulbOutlined /> },
    { label: "Programs", key: "programs", icon: <BookOutlined /> },
    { label: "Photos", key: "photos", icon: <PictureOutlined /> },
    { label: "Contact", key: "Contact", icon: <PhoneOutlined /> },
  ];

  const onClick = (e) => {
    setCurrent(e.key);
    const section = document.getElementById(e.key);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-12 text-black text-start pb-4">
          <div className="row align-items-center d-flex justify-content-between flex-nowrap">
            {/* Logo Placeholder */}
            <div className="col-auto">
              <img src={schoolLogo} alt="School logo" className="school-logo" />
            </div>

            {/* Ant Design Menu */}
            <div className="col flex-grow-1 d-flex justify-content-center menu-container">
              <Menu
                onClick={onClick}
                selectedKeys={[current]}
                mode="horizontal"
                items={item}
                className="border-0 responsive-menu"
                style={{ fontFamily: "Aceh SoftRegular"}}  
              />
            </div>

            <div className="col-auto" >
              <button className="btn btn-danger enquire-btn" onClick={() => window.alert("Call Us at +91-9960132474 / +91-9370130130")}>Enquire</button>
            </div>
          </div>
        </div>

        <div className="col-12 p-0 position-relative">
          <img src={themepicture} alt="TeacherAndChildrenImage" className="main-image" />
        </div>

        {/* Content Sections */}
        <div className="col-12 d-flex flex-column align-items-center text-center p-3 mt-4" id="Why Achiever">
          <h1 className="fw-bold section-heading"><b>Why Achiever's</b>  🏆</h1>
          <h2 className="mt-2 section-subheading">
            No two kids are the same, then why should they learn the same thing, the same way and at the same pace as every other kid?
          </h2>
          <h5 className="mt-3 section-description">
            At Achievers, we believe that every child is unique with innovative skills and abilities that need nurturing. 
            With this philosophy at the heart of everything we do, we have developed a personalized learning methodology 
            that involves skill-based lessons and engaging activities that enable your child to hone his/her individual abilities.
          </h5>
        </div>


        <div className="col-12 p-3 section-content text-center" >
          <div className="container text-center"> 
            {/* Title */}
            <h2 className="section-title">
              <b>Our School</b>
            </h2>

            {/* Image */}
            <div className="d-flex justify-content-center">
              <img src={ourSchool} alt="Our School" className="school-image" />
            </div>

            {/* Description */}
            <div className="d-flex flex-column align-items-center text-center">
              <h4 className="section-description">
                At <b>Achiever’s School</b>, we create a <b>nurturing</b> and <b>inspiring</b> space where young minds 
                <b> learn, play, and grow</b> with <b>curiosity and confidence</b>. Our <b>child-centered approach </b> 
                encourages <b>creativity</b>, <b>critical thinking</b>, and a <b>lifelong love for learning</b>.  
                <br /><br />
                ✨ <b>Why Choose Us?</b>
                <ul style={{listStyleType: "none"}}>
                    <li>✅ <b>A safe and engaging environment</b> for your child’s development</li>
                    <li>✅ <b>Fun-filled learning</b> that sparks imagination and discovery</li>
                    <li>✅ <b>A strong foundation</b> to help every child achieve their full potential!</li>
                </ul>
                <br />
                <b>Join us</b> on this wonderful journey of <b>growth and learning!</b> 🚀🎨📚
              </h4>
            </div>
          </div>
        </div>

        <div className="col-12 p-3 section-content text-center">
          {/* Title */}
          <h2 className="section-title">
            <b>A learning experience as unique as your child</b>
          </h2>

          {/* Image */}
          <div className="d-flex justify-content-center py-5">
            <img src={studentActivity} alt="Our School" className="activity-image" />
          </div>

          {/* Description */}
          <div className="d-flex flex-column align-items-center text-center">
            <h4 className="section-description">
              We <b>customize learning</b> for each child based on their <b>strengths, needs, and skill level</b>,  
              ensuring that every child stays <b>engaged and happy</b>.  
              <br /><br />
              At Achiever’s School, children learn at their <b>own pace</b>, unlocking new levels of learning  
              <b> only when they have mastered an activity</b>. This builds confidence, independence, and a  
              love for discovery! 🌟📚🎈
            </h4>
          </div>
        </div>

        <div className="col-12 p-3 mt-4" id="programs">
          <h1 className="section-heading"> <b>Programs</b>  📚</h1>
        </div>

        <div className="programs-tabs-container" >
            {!isMobile ? (
              <ProgramsTabs />
              ) : (
                <div className='d-flex justify-content-center'>
                  <Collapse className="programs-accordion-container">
                    {items.map((item) => (
                    <Collapse.Panel header={item.label} key={item.key}>
                      {item.children}
                    </Collapse.Panel>
                    ))}
                  </Collapse>
                </div>
              )
            }
          </div>

        <div className="col-12 p-3 mt-4" id="photos">
          <h1 className="section-heading"><b>Photos  📸</b></h1>
          <Carousel autoplay style={{ marginTop: "1cm" }}>
            {/* Carousel Items */}
            <div>
              <img src={schoolphoto1} alt="schoolPhoto" className="carousel-image" />
            </div>
            <div>
              <img src={schoolphoto3} alt="schoolPhoto" className="carousel-image" />
            </div>
            {/* Other images go here */}
            <div>
                <img src={schoolphoto3} alt="schoolPhoto" className='carousel-image' />
            </div>
            <div>
                <img src={schoolphoto4} alt="schoolPhoto" className='carousel-image' />
            </div>
            <div>
                <img src={schoolphoto6} alt="schoolPhoto" className='carousel-image' />
            </div>
            <div>
                <img src={schoolphoto8} alt="schoolPhoto" className='carousel-image' />
            </div>
            <div>
                <img src={schoolphoto9} alt="schoolPhoto" className='carousel-image' />
            </div>
            <div>
                <img src={schoolphoto10} alt="schoolPhoto" className='carousel-image' />
            </div>
            <div>
                <img src={schoolphoto11} alt="schoolPhoto" className='carousel-image' />
            </div>
            <div>
                <img src={schoolphoto12} alt="schoolPhoto" className='carousel-image' />
            </div>
          </Carousel>
        </div>

        <div className="col-12 text-center p-3 mt-4" id="Contact">
          <h1 className="section-heading"><b>Contact  ☎️</b></h1>
          <h3 className="section-description">
            <EnvironmentOutlined /> Address 1: Achiever's School, Krushna Kunj Phase - 1...
          </h3>
          <h3 className="section-description">
            <PhoneOutlined /> Contact: +91-9960132474 / +91-9370130130
          </h3>
          <h3 className="section-description">
            <MailOutlined /> E-Mail: achievers.school.lonikand@gmail.com
          </h3>
        </div>
      </div>
    </div>
  );
}

